<template>
    <div>
        <hts-tooltip>
            <span >
                {{ CRequest }}
            </span>
            <template #reference>
                {{ CRequest }}
            </template>
        </hts-tooltip>
    </div>
</template>

<script lang="ts" setup>
const { $formatters } = useNuxtApp()

const props = defineProps({
  params: Object
})

const { params } = toRefs(props)

const CRequest = computed(() => {
  const { request } = params?.value?.data
  return request
})

</script>

<style scoped></style>
